import { render, staticRenderFns } from "./monev_kabupaten.vue?vue&type=template&id=1b6b865e&"
import script from "./monev_kabupaten.vue?vue&type=script&lang=js&"
export * from "./monev_kabupaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports